const MainCourseReducer = (state = { mainCourse: 0 }, action) => {
  switch (action.type) {
    case "MainCourse":
      return { ...state, mainCourse: action.payload };
    // case "decMainCourse":
    //   return { ...state, mainCourse: action.payload };
    default:
      return state;
  }
};
export default MainCourseReducer;
